var cifUa = ["301 201", "<g fill='none'><path fill='#005BBB' d='M.5.5h300v200H.5z'/><path fill='#FFD500' d='M.5 100.5h300v100H.5z'/></g>"];

export { cifUa };

